import {
  BaseModal,
  Button,
  Content,
  Flex,
  fromTheme,
  IconButton,
  StrokeIcon,
} from '@acsbe/ui';
import { styled } from 'styled-components';

interface TurnOffWidgetPopupProps {
  onClose: () => void;
  onStayAccessible: () => void;
  onTurnOffWidget: () => void;
  isProcessing?: boolean;
}

export const TurnOffWidgetPopup = (props: TurnOffWidgetPopupProps) => {
  const onClose = () => {
    props.onClose();
  };

  const onStayAccessible = () => {
    props.onStayAccessible();
    props.onClose();
  };

  const onTurnOffWidget = () => {
    props.onTurnOffWidget();
    props.onClose();
  };

  return (
    <>
      <StyledModal open={true} closeButton>
        <CloseButton
          aria-label="Close"
          padding={1.5}
          scale="alternative"
          variant="solid"
          radius="round"
          onClick={() => onClose()}
        >
          <StrokeIcon name="Close" size="lg" />
        </CloseButton>
        <Flex padding={8} paddingBlockStart={6} gap={8}>
          <Flex>
            <Flex gap={4}>
              <Heading>Turn off accessWidget?</Heading>
              <SubHeading>
                Your store may no longer be accessible to visitors with
                disabilities.
              </SubHeading>
            </Flex>
          </Flex>
          <Flex gap={4} justify="end" row>
            <StayAccessibleButton
              scale="ghost"
              onClick={() => onStayAccessible()}
              disabled={props.isProcessing}
            >
              <span>Stay Accessible</span>
            </StayAccessibleButton>
            <Button
              scale="danger"
              onClick={() => onTurnOffWidget()}
              disabled={props.isProcessing}
            >
              <span>Turn off accessWidget</span>
            </Button>
          </Flex>
        </Flex>
      </StyledModal>
    </>
  );
};

const StayAccessibleButton = styled(Button)`
  border: 1px solid #cbd2e1;
`;

const StyledModal = styled(BaseModal)`
  max-width: 520px;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  inset-block-start: 5px;
  inset-inline-end: 5px;
  background-color: transparent;
  color: #394c61;
`;

const Heading = styled(Flex)`
  font-size: 28px;
  font-weight: 700;
  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 22px;
  }
`;

const SubHeading = styled(Content)`
  font-size: 18px;
  line-height: 27px;
  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 14px;
    line-height: 21px;
  }
`;
